import * as Sentry from "@sentry/react";

export function initSentry() {
  if (window.location.hostname === "localhost") return;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV || import.meta.env.MODE,
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}

export { Sentry };
